import { eventEmitter } from "../../events/eventEmitter";
import { Event, RequestErrorEvent, RequestSuccessEvent } from "../../events/events";
import { User, currentUser } from "../api/AuthUser";
import { setCookie } from "./cookies";

export class BackendRequestError extends Error {}

// TODO: Wrap this into static class and implement success message similar to backend error above.
// For instance, message can be: Successfully created ${endpoint}.
export async function request(
  url: URL,
  request: RequestInit,
  withAuth: boolean,
  successMessage?: string | undefined,
): Promise<Response> {
  eventEmitter.emit(Event.BackendRequestStart);

  try {
    if (withAuth) request.headers = { Authorization: `Bearer ${currentUser.getValidToken()}` };
    const response = await fetch(url, request);
    if (!response.ok) {
      if (response.status === 401) {
        setCookie("token", "", -1);
        User.redirectToLoginPage();
      }

      const json = await response.json();
      const errorMessage = json?.message || response.statusText;
      const err = new BackendRequestError(errorMessage);

      eventEmitter.emit(Event.BackendRequestError, {
        error: err,
      } as RequestErrorEvent);

      // Always return the error to the caller, so they can handle it if needed.
      throw err;
    }

    eventEmitter.emit(Event.BackendRequestSuccess, {
      method: request.method,
      message: successMessage,
    } as RequestSuccessEvent);

    return response;
  } finally {
    (async () => {
      // Just let the loading animation run through at least a cycle
      await new Promise((resolve) => setTimeout(resolve, 1125));
      eventEmitter.emit(Event.BackendRequestEnd);
    })();
  }
}
